// extracted by mini-css-extract-plugin
module.exports =  {"descriptionElements":"F7CjAHZNox4rQbwPjVeM","chips":"VXfQo3L1_b4Y_1gbjxE0","chip":"Iaq4kozxG2KNJddNTFBw","avatar":"ty8iXWCSEJskeVPFn0yl"};